// TECH-9684
// eslint-disable-next-line no-unused-vars
window.updateGamAdUrl = function(elementToUpdate, signupLocation) {
  const objectToUpdate = $(elementToUpdate);
  const originalHref = objectToUpdate.attr('href');

  if (!originalHref) {
    return;
  }

  // JS url parsing doesn't work because adurl can have its own params
  let adUrlParam = originalHref.split('adurl=')[1];

  /* We always add the signup_location and signup_path to ads with adUrls b/c we don't
  have a good way to determine a signup ad. And if there are additional links w/o
  an adurl, then we exit earlier. */
  if (adUrlParam === undefined) {
    return;
  }

  const adUrl = new URL(adUrlParam);
  // eslint-disable-next-line no-restricted-globals
  const signupPath = location.pathname;

  // make sure we don't add the params more than once
  if (adUrlParam.includes('signup_location')) {
    return;
  }

  const reIndustryDiveLink = /(http|https):\/\/www\.((\w+dive)|(pharmavoice)|(socialmediatoday)|(cfo))\.com\/(link|signup)/;
  /* Only add params to Industry Dive sites that support newsletters.
  The links we anticipate will use either the divelink app, its urls
  (url(r'^link/(?P<pk>\d+)/$', link_view, name='divelink')) located
  in urls.py, or a signup/ page, which has many urls also located in urls.py. */
  if (reIndustryDiveLink.test(adUrlParam)) {
    // clear any params that might follow in case adurl is not the last one
    // note: this must follow the signup_location check or else it duplicates the params
    // eslint-disable-next-line prefer-destructuring
    adUrlParam = adUrlParam.split('&')[0];

    // check if there's already recognized querystring or an encoded one
    // in order to decide whether to add or append the new parameters
    const querystringExists = adUrl.search || adUrlParam.includes('%3F');
    const queryStringChar = querystringExists ? '&' : '?';

    // replace the adUrl whether it exists in the string with the new value
    const value = `${adUrlParam}${queryStringChar}signup_location=housead-${signupLocation}&signup_path=${signupPath}`;
    const newHref = originalHref.replace(/(adurl=)[^&]+/, `$1${value}`);
    objectToUpdate.attr('href', newHref);
  }
};
